{
  "name": "@nicolaudie-group/profile-builder",
  "displayName": "Profile Builder",
  "version": "2.7.1",
  "private": true,
  "type": "module",
  "bin": {
    "pb-upload-translations": "./scripts/uploadTranslations.mjs"
  },
  "scripts": {
    "dev": "vite",
    "serve": "vite",
    "start": "vite",
    "build": "run-p type-check \"build-only {@}\" --",
    "preview": "vite preview",
    "test:unit": "vitest",
    "test:e2e": "playwright test",
    "build-only": "vite build",
    "type-check": "vue-tsc --build",
    "lint": "run-s \"lint:*\"",
    "lint:oxlint": "oxlint . --fix",
    "lint:eslint": "eslint . --fix --cache",
    "prepare": "husky",
    "check": "echo 'nothing to do'",
    "deploy": "bash ./node_modules/@nicolaudie-group/boilerplate/extends/deploy-default.sh",
    "doc": "echo 'nothing to do'",
    "translations": "./scripts/uploadTranslations.mjs"
  },
  "dependencies": {
    "@nicolaudie-group/ls-utilities": "^6.12.0",
    "@nicolaudie-group/lscore-sdk2-ts": "^3.48.2",
    "@nicolaudie-group/lscore-sdk3-ts": "^3.48.2",
    "@nicolaudie-group/ng-ui-kit": "^10.8.3",
    "@nicolaudie-group/translation-management-system": "^1.1.3",
    "@nicolaudie-group/typing": "^1.16.0",
    "@vue/compat": "^3.5.40",
    "@vueuse/core": "^13.6.0",
    "@vueuse/router": "^13.6.0",
    "core-js": "^3.36.1",
    "pinia": "^2.1.7",
    "vue": "^3.5.40",
    "vue-router": "^4.3.0"
  },
  "devDependencies": {
    "@commitlint/cli": "^19.2.1",
    "@commitlint/config-conventional": "^19.1.0",
    "@nicolaudie-group/boilerplate": "^2.5.4",
    "@playwright/test": "^1.61.1",
    "@tsconfig/node24": "^24.0.4",
    "@types/jsdom": "^28.0.3",
    "@types/node": "^24.13.3",
    "@vite-pwa/assets-generator": "^1.0.2",
    "@vitejs/plugin-vue": "^6.0.8",
    "@vitest/eslint-plugin": "^1.6.23",
    "@vue/eslint-config-typescript": "^14.9.0",
    "@vue/test-utils": "^2.4.11",
    "@vue/tsconfig": "^0.9.1",
    "eslint": "^10.7.0",
    "eslint-plugin-oxlint": "~1.73.0",
    "eslint-plugin-playwright": "^2.10.5",
    "eslint-plugin-vue": "~10.9.2",
    "eslint-plugin-vuejs-accessibility": "^2.2.1",
    "husky": "^9.0.11",
    "jiti": "^2.7.0",
    "jsdom": "^29.1.1",
    "npm-run-all2": "^9.0.2",
    "oxlint": "~1.73.0",
    "sass": "^1.102.0",
    "typescript": "~6.0.0",
    "vite": "^8.1.5",
    "vite-plugin-pwa": "^1.3.0",
    "vite-plugin-vue-devtools": "^8.1.5",
    "vitest": "^4.1.10",
    "vue-eslint-parser": "^10.4.1",
    "vue-tsc": "^3.3.7",
    "workbox-window": "^7.4.1"
  },
  "engines": {
    "node": "^22.18.0 || >=24.12.0"
  }
}
